import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  > img {
    width: auto;
    height: 600px;
  }

  > span {
    font-size: 40px;
  }
`;

export const Header = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 100%;
  padding: 20px 0px;

  > span {
    margin-left: 20px;
    font-size: 20px;
  }
`;
